import React, { useState } from 'react';
import { useGlobal } from 'reactn';
import CryptoJS from 'crypto-js';
import dollarIcon from '../assets/dollarIcon.png';
import Button from '../common/button/Button';

import api from '../../api';

const SPEED_PAY_URL = process.env.REACT_APP_SPEEDPAY_URL;
const SPEED_PAY_ONETIME_URL = process.env.REACT_APP_API_SPEEDPAY_ONETIME_URL

// make a form post request with the given parameters
const post = (path, params, method = 'post') => {
  const form = document.createElement('form');
  form.method = method;
  form.action = path;

  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      const hiddenField = document.createElement('input');
      hiddenField.type = 'hidden';
      hiddenField.name = key;
      hiddenField.value = params[key];

      form.appendChild(hiddenField);
    }
  }

  document.body.appendChild(form);
  form.submit();
};

// get speedpay key and timestamp from server
const getKeyAndTimestamp = async () => {
  const res = await api.getSpeedpayKey();
  if (res.error) {
    console.error({ SpeedpayKeyError: res.error });
  }
  return res;
};

// construct post payload and send user to speedpay
const postToSpeedpay = async ({ id, customerAccount, email }) => {
  const { speedpayKey, timestamp } = await getKeyAndTimestamp();
  const account = customerAccount.ACCOUNT;
  const payload = `sp_credit_account=${account}|^|Timestamp=${timestamp}|^|EmailAddress=${email}|^|ID=${id}`;
  const encrypted = CryptoJS.AES.encrypt(
    payload,
    CryptoJS.enc.Base64.parse(speedpayKey),
    {
      iv: CryptoJS.lib.WordArray.random(16 /* bytes */),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );
  const iv = CryptoJS.enc.Base64.stringify(encrypted.iv);

  post(SPEED_PAY_URL, { IV: iv, timestamp, post_data: encrypted });
};

const Speedpay = ({ customerAccount, btnClassname }) => {
  const [loading, setLoading] = useState(false);
  const [user] = useGlobal('user');
  const { id, email } = user;

  return (
    <Button
      iconUrl={dollarIcon}
      loading={loading}
      className={`w-full ${btnClassname}`}
      onClick={() => {
        setLoading(true);
        postToSpeedpay({ id, email, customerAccount });
      }}
    >
      Make a Payment <br/>($1.45 fee/transaction)
    </Button>
  );
};

export default Speedpay;
